module.exports = __webpack_public_path__ + "static/media/dmg.12e0a126.svg";